import { API_SDK_URL } from '@env';
import { SessionApiService } from '@marpla/api-sdk';
import { enqueueSnackbar } from '@marpla/ui/components/SnackbarProvider';

import { HttpAgent } from './http.agent';

const BASE_URL = API_SDK_URL;

export function createHttpAgent(baseUrl: string = BASE_URL): HttpAgent {
  const agent = new HttpAgent(enqueueSnackbar);

  if (baseUrl) {
    agent.setBaseUrl(baseUrl);
  }

  return agent;
}

let sessionApiService: SessionApiService | undefined;

export function getSessionApiService(): SessionApiService {
  return (sessionApiService ??= new SessionApiService(createHttpAgent()));
}
